import React from 'react';

const Background = ( { children } ) =>

{
    return (
        <div className="w-auto h-auto min-h-screen transition-all duration-150 ease-in-out min-w-screen bg-slate-200 dark:bg-[#050d18]">
            {children}
        </div>
    )
}

export default Background;
